import { LockOutlined, UserOutlined } from '@ant-design/icons'
import { Avatar, Button, Form, Input, Switch } from 'antd'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useMediaQuery } from 'react-responsive'
import styled from 'styled-components'
import logoImage from '../../../assets/images/logo192.png'
import { translate } from '../../../languages'
import { RootState } from '../../../stores'
import { login, setLanguage } from '../../../stores/actions'

const AvatarAction = styled.div`
  margin-top: -2.5px;
  line-height: 64px;
  cursor: pointer;
  transition: color 0.3s;
  margin: auto;
`

export const LoginPage: React.FC = () => {
  const dispatch = useDispatch()

  const { language } = useSelector((state: RootState) => state.language)
  const { error, logining } = useSelector((state: RootState) => state.auth)
  const [username, setUsername] = React.useState('')
  const [password, setPassword] = React.useState('')
  const isMobile = useMediaQuery({ maxWidth: '550px' })
  const isTablet = useMediaQuery({ minWidth: '551px', maxWidth: '1023px' })

  const submitLoginHandler = async (e: React.FormEvent) => {
    e.preventDefault()
    dispatch(login(username, password))
  }

  return (
    <Form
      style={{
        padding: '20px 20px 30px',
        maxWidth: '600px',
        margin: 'auto',
        borderRadius: '10px',
        boxShadow: '5px 8px 24px 5px rgba(208, 216, 243, 0.6)',
        marginTop: isMobile ? '75px' : isTablet ? '150px' : '200px',
        backgroundColor: 'whitesmoke',
      }}
    >
      <Form.Item
        style={{
          textAlign: 'center',
          fontWeight: 'bold',
          color: 'blue',
          margin: '20px auto',
          maxWidth: '300px',
          fontSize: '1.2rem',
        }}
      >
        <AvatarAction>
          <Avatar size={100} src={logoImage} />
        </AvatarAction>
        <Switch
          checkedChildren="EN"
          unCheckedChildren="VI"
          defaultChecked={language === 'EN'}
          onChange={(e) => dispatch(setLanguage(e ? 'EN' : 'VI'))}
        />
      </Form.Item>
      <Form.Item
        style={{ maxWidth: '300px', margin: '20px auto' }}
        rules={[
          {
            required: true,
            message: translate('auth.required.username', language),
          },
        ]}
      >
        <Input
          prefix={<UserOutlined />}
          placeholder={translate('auth.username', language)}
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          disabled={logining}
        />
      </Form.Item>
      <Form.Item
        style={{ maxWidth: '300px', margin: '20px auto' }}
        rules={[
          {
            required: true,
            message: translate('auth.required.password', language),
          },
        ]}
      >
        <Input
          prefix={<LockOutlined />}
          type="password"
          placeholder={translate('auth.password', language)}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          disabled={logining}
        />
      </Form.Item>
      {error && (
        <Form.Item
          style={{
            color: 'red',
            maxWidth: '300px',
            margin: '20px auto',
          }}
        >
          {error}
        </Form.Item>
      )}
      <Form.Item style={{ maxWidth: '300px', margin: '20px auto' }}>
        <Button
          type="primary"
          style={{ width: '100%' }}
          disabled={logining}
          htmlType="submit"
          onClick={submitLoginHandler}
        >
          {translate('auth.login', language)}
        </Button>
      </Form.Item>
    </Form>
  )
}
